import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';

export function* getProfileInfo() {
  try {
    const res = yield call(api, {
      method: 'get',
      url: URL.PROFILE,
    });
    const { data } = res;
    yield put({ type: 'GET_PROFILE_INFO_SUCCESS', data });
  } catch (e) {
    yield put({ type: 'GET_PROFILE_INFO_ERROR' });
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.GET_PROFILE_INFO, getProfileInfo);
}
